import moment from "moment-timezone";

export const dateFormatter = (date: Date, tz: string = moment.tz.guess()) => {
  return moment.tz(date, tz || moment.tz.guess()).format("l LTS z");
};

export const dateFormatterWithoutTime = (date: Date, tz: string = moment.tz.guess()) => {
  return moment.tz(date, tz || moment.tz.guess()).format("l");
};
